import React from 'react';
import { Lightbulb, AlertTriangle, Info } from 'lucide-react';

const TAG_LABEL = {
  referral: 'Referral', authorization: 'Prior auth', timely_filing: 'Timely filing',
  cost: 'Cost', coverage: 'Coverage',
};
const SEV = {
  high: { row: 'border-rose-100 bg-rose-50', icon: 'text-rose-600', Icon: AlertTriangle, chip: 'pill-red' },
  warn: { row: 'border-amber-100 bg-amber-50', icon: 'text-amber-600', Icon: AlertTriangle, chip: 'pill-amber' },
  info: { row: 'border-slate-200 bg-slate-50', icon: 'text-slate-500', Icon: Info, chip: 'pill-slate' },
};

// What we've learned about this plan from past visits + claims — referral/auth
// quirks, common denials, cost notes. The closes-the-loop differentiator: every
// appointment on a plan inherits the practice's accumulated understanding of it.
export default function PlanLearnings({ learnings = [] }) {
  if (!learnings.length) return null;
  return (
    <div className="dh-card p-5">
      <div className="flex items-center gap-2 text-sm font-semibold text-slate-900 mb-1">
        <Lightbulb className="h-4 w-4 text-amber-500" />Plan learnings
      </div>
      <p className="text-xs text-slate-500 mb-3">What the practice has learned about this plan — applied to every appointment on it.</p>
      <div className="space-y-2">
        {learnings.map((l) => {
          const sev = SEV[l.severity] || SEV.info;
          const Icon = sev.Icon;
          return (
            <div key={l.id} className={`flex items-start gap-2.5 rounded-lg border px-3 py-2.5 ${sev.row}`}>
              <Icon className={`h-4 w-4 mt-0.5 shrink-0 ${sev.icon}`} />
              <div className="min-w-0 flex-1">
                <div className="text-sm text-slate-800">{l.learning}</div>
                <div className="mt-1 flex items-center gap-2 flex-wrap">
                  {l.tag && <span className={`pill ${sev.chip}`}>{TAG_LABEL[l.tag] || l.tag}</span>}
                  {l.occurrences > 0 && <span className="text-[11px] text-slate-500 tnum">seen {l.occurrences}×</span>}
                  {l.source && <span className="text-[11px] text-slate-400">· {String(l.source).replace(/_/g, ' ')}</span>}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
